module.exports = __webpack_public_path__ + "img/cozia.01c81ead.jpg";